import classNames from 'classnames';
import dayjs from 'dayjs';

import { MessageEvent } from 'utils/enums';
import { DateFormat } from 'utils/date';

import { AppointmentMessageProps } from './appointmentMessage.types';

const AppointmentMessage: React.FC<AppointmentMessageProps> = ({ combined, message, self }) => {
  const isCreated = message.event === MessageEvent.AppointmentCreated;

  const appointmentStatusClassName = classNames('mt-1 font-medium text-gray whitespace-normal', {
    'line-through': !isCreated
  });
  const appointmentDate = message.appointmentDate
    ? dayjs(message.appointmentDate).format(DateFormat.MMM_D_h_mma_z)
    : '';

  return (
    <div
      className={classNames(
        'w-fit max-w-[270px] rounded-xl px-5 py-3',
        self ? 'bg-secondary-100' : 'bg-gray-100',
        !combined && (self ? 'rounded-br-none' : 'rounded-bl-none')
      )}
    >
      <p className="font-bold text-gray-700">Appointment {isCreated ? 'created' : 'canceled'}</p>
      <p className={appointmentStatusClassName}>{message.appointmentType}</p>
      {!!appointmentDate && <p className={appointmentStatusClassName}>{appointmentDate}</p>}
      {message.message && !!appointmentDate && (
        <p className="mt-3 font-medium whitespace-normal text-gray-700">{message.message}</p>
      )}
    </div>
  );
};

export default AppointmentMessage;
